import { styled } from "styled-components";

export const ContentContainer = styled.div`
    display: flex;
    margin-top: 15px;
    gap: 20px;
    padding: 0 20px;

    @media (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
    }
`

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    max-width: 100px;
    width: 100%;
    &:focus {
        border-color: #007bff;
    }
    @media (max-width: 768px) {
        max-width: 100%;
        box-sizing: border-box;
    }
`;

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
    max-width: 300px;
    width: 100%;
    padding-right: 15px;
    flex: 1;

    @media (max-width: 768px) {
        text-align: left;
        padding-right: 0;
    }
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;

    @media (max-width: 1100px) {
        max-width: 600px;
    }
`

export const ChartContainer = styled.div`
    position: relative;
    width: 100%;
    margin: auto;
    max-width: 1200px;
    position: relative;

    @media (max-width: 1100px) {
        margin-top: 30px;
    }
`

export const ModelSIS = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const ModelSIR = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const ModelSEIRD = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const Modelchoice = styled.div`
    display: inline-block;
    margin: 5px;
    margin-left: 25px;
    max-width: 400px;
`

export const InputRadioButton = styled.input`
    
`
export const ModelText = styled.div`
    border-top-style: solid;
    border-bottom-style: solid;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: #8d8d8d;
    font-weight: bold;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
`